
export class DistanceField {
  _feets: number = 0
  _meters: number = 0

  get feets(){return this._feets}
  set feets(value: number) {
    this._feets = value;
    this._meters = DistanceField.feetToMeters(value);
  }

  get meters(){return this._meters}
  set meters(value: number) {
    this._meters = value;
    this._feets = DistanceField.metersToFeet(value);
  }

  static metersToFeet(value:number):number{
    return Math.round((value / 0.3048) * 100) / 100;
  }

  static feetToMeters(value:number):number{
    return Math.round((value / 3.28084) * 100) / 100;
  }
}

export class PowerField {
  _dBW: number;
  _dBm: number;

  constructor(initial:number = null) {
    if (initial != null) this.dBW = initial;
  }

  get dBW(){return this._dBW != undefined ? Number(this._dBW?.toFixed(2)) : this._dBW}
  set dBW(value: number) {
    this._dBW = value;
    this._dBm = PowerField.dbwToDbm(value);
  }

  get dBm(){return this._dBm != undefined ? Number(this._dBm?.toFixed(2)) : this._dBm}
  set dBm(value: number) {
    this._dBm = value;
    this._dBW = PowerField.dbmToDbw(value);
  }

  static dbwToDbm(value:number): number{
    return value + 30;
  }

  static dbmToDbw(value:number):number{
    return value - 30;
  }
}
